import { gql } from '@apollo/client';

export const IS_LOGGED_IN = gql`
  query Query {
    isLoggedIn {
      status
      urltag
      user {
        email
        role
        offices {
          urltag
          name
          is_default
        }
      }
    }
  }
`;
